<template>
	<el-row>
		<el-button type="primary" plain @click="add">+添加</el-button>
		<el-table :data="tableData" style="margin-top: 20px;" row-key="id"
			:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
			<el-table-column label="序号" prop="id"></el-table-column>
			<el-table-column prop="name" label="导航名称"></el-table-column>
			<el-table-column prop="sort" label="排序"></el-table-column>
			<el-table-column prop="lastupdated" label="编辑时间"></el-table-column>
			<el-table-column prop="status" label="状态">
				<template slot-scope="scope">
					<el-switch :active-value="0" :inactive-value="1" @change="isStatus(scope.row)" active-text="正常"
						inactive-text="禁用" v-model="scope.row.status">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column prop="address" label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="del(scope.row)" style="color: #ff6666;">删除</el-button>
					<el-button v-if="scope.row.parentId == -1" type="text" @click="xiugai1(scope.row)"
						style="color: #0066ff;">修改</el-button>
					<el-button v-if="scope.row.parentId != -1" type="text" @click="xiugai2(scope.row)"
						style="color: #0066ff;">编辑</el-button>
					<el-button v-if="scope.row.parentId != -1" type="text" style="color: #00cc33;"
						@click="bianji(scope.row)">文章管理</el-button>
					<el-button v-if="scope.row.parentId == -1" type="primary" @click="tianjia(scope.row)" size="mini">添加
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog :title="title" :visible.sync="centerDialogVisible" width="25%" center>
			<el-form ref="info" :model="info" label-position="right" label-width="90px">
				<div v-if="isShow">
					<el-form-item label="导航名称:" prop="name" :rules="[
                        { required: true, message: '请输入导航名称', trigger: 'blur' }
                      ]">
						<el-input size="mini" v-model="info.name"></el-input>
					</el-form-item>
				</div>
				<div v-else>
					<!-- <el-form-item label="一级导航:">
						{{info.name}}
					</el-form-item> -->
					<el-form-item label="二级导航" prop="name2" :rules="[
                        { required: true, message: '请输入二级导航', trigger: 'blur' }
                      ]">
						<el-input size="mini" v-model="info.name2"></el-input>
					</el-form-item>
				</div>
				<el-form-item label="导航排序" prop="sort" :rules="[
                      { required: true, message: '请输入导航排序', trigger: 'blur' }
                    ]">
					<el-input-number v-model="info.sort" :min="1"></el-input-number>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click='queren'>确认</el-button>
					<el-button type="infor" @click="centerDialogVisible = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				isShow: true,
				title: "",
				info: {
					id: '',
					name: "",
					sort: '',
					name2: "",
					sort2: '',
					parentId: '',
				},
				centerDialogVisible: false,
				tableData: [],
				total: 0,
				pageNum: 1,
				pageSize: 30,
				pagelist: [30, 50, 100],
			}
		},
		methods: {
			isStatus(row) {
				console.log(row.status);
				this.$http.post("/api/course/ClrArticleConteoller/edit", {
					status: row.status == 1 ? 1 : 0,
					id: row.id,
				}).then(res => {
					this.getInfo()
				})
			},
			del(row) {
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post("/api/course/ClrArticleConteoller/edit", {
						deleteStatus: 1,
						id: row.id,
					}).then(res => {
						if (res.data.status == 0) {
							this.$message.success('删除成功')
							this.centerDialogVisible = false
							this.getInfo()
						} else {
							this.$message.error('删除失败')
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			add() {
				this.title = '添加'
				this.centerDialogVisible = true
				this.isShow = true
				this.info.name = ''
				this.info.sort = ''
			},
			xiugai1(row) {
				this.title = '修改'
				this.centerDialogVisible = true
				this.isShow = true
				this.info.name = row.name
				this.info.sort = row.sort
				this.info.id = row.id
			},
			xiugai2(row) {
				console.log(row);
				this.title = '编辑'
				this.centerDialogVisible = true
				this.isShow = false
				this.info.name2 = row.name
				this.info.sort = row.sort
				this.info.id = row.id
			},
			tianjia(row) {
				console.log(row);
				this.title = '添加二级'
				this.centerDialogVisible = true
				this.isShow = false
				this.info.name2 = ''
				this.info.parentId = row.id
			},
			queren() {
				this.$refs.info.validate((vai) => {
					if (vai) {
						if (this.title == '添加') {
							this.$http.post("/api/course/ClrArticleConteoller/add", {
								name: this.info.name,
								sort: this.info.sort,
								parentId: -1
							}).then(res => {
								if (res.data.status == 0) {
									this.$message.success('添加成功')
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error(res.data.msg)
								}
							})
						} else if (this.title == '添加二级') {
							this.$http.post("/api/course/ClrArticleConteoller/add", {
								name: this.info.name2,
								sort: this.info.sort,
								parentId: this.info.parentId
							}).then(res => {
								if (res.data.status == 0) {
									this.$message.success('添加成功')
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error(res.data.msg)
								}
							})
						} else if (this.title == '修改') {
							console.log(this.info.id);
							this.$http.post("/api/course/ClrArticleConteoller/edit", {
								name: this.info.name,
								sort: this.info.sort,
								id: this.info.id,
							}).then(res => {
								if (res.data.status == 0) {
									this.$message.success('修改成功')
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error('修改失败')
								}
							})
						} else if (this.title == '编辑') {
							console.log(this.info.id);
							this.$http.post("/api/course/ClrArticleConteoller/edit", {
								name: this.info.name2,
								sort: this.info.sort,
								id: this.info.id,
							}).then(res => {
								if (res.data.status == 0) {
									this.$message.success('编辑成功')
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error('编辑失败')
								}
							})
						}

					}
				})
			},
			bianji(row) {
				this.$router.push({
					path: './editor',
					query: {
						articleId: row.id
					}
				})
			},
			getInfo() {
				this.$http.get(
					`/api/course/ClrArticleConteoller/selectList?pageSize=${this.pageSize}&pageNum=${this.pageNum}`, {}
				).then(res => {
					console.log(res.data.data);
					this.tableData = res.data.data
					this.total = res.data.data.length
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getInfo()
			},
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style scoped="scoped">
	/deep/.el-input-number__increase {
		right: -38px;
	}
</style>
